import { ColorManagement, LinearSRGBColorSpace, WebGLRenderer } from 'three'
import { OutlineEffect } from 'three/examples/jsm/effects/OutlineEffect'
import Constants from './Constants'

export default class Renderers
{
    constructor(_options)
    {
        this.time = _options.time
        this.sizes = _options.sizes
        this.scene = _options.scene
        this.camera = _options.camera

        this.setRenderer()
        this.setOutlineEffect()
        this.sizes.resize()
    }

    setRenderer()
    {
        this.renderer = new WebGLRenderer({ alpha: false, premultipliedAlpha: false, antialias: true, powerPreference: "high-performance" })
        this.renderer.shadowMap.enabled = true
        this.renderer.setClearColor(Constants.COLORS.bgColor)

        // Imposto i colori "legacy" dopo aggiornamento a versione r152
        this.renderer.outputColorSpace = LinearSRGBColorSpace
        ColorManagement.enabled = false

        document.querySelector("#webgl").appendChild(this.renderer.domElement)
        this.sizes.on('resize', () =>
        {
            this.renderer.setSize(this.sizes.width, this.sizes.height)
            this.renderer.setPixelRatio(this.sizes.pixelRatio)
        })
    }

    setOutlineEffect()
    {
        this.outlineEffect = new OutlineEffect(this.renderer,
        {
            defaultThickness: 0.001,
            defaultColor: [0.63, 0.60, 0.57],
            defaultAlpha: 1.0,
        })
        this.sizes.on('resize', () =>
        {
            this.outlineEffect.setSize(this.sizes.width, this.sizes.height)
            this.outlineEffect.setPixelRatio(this.sizes.pixelRatio)
        })
    }

    activateRenderer()
    {
        this.time.on('tick', () =>
        {
            this.outlineEffect.render(this.scene, this.camera.instance)
        })
    }
}